import React from 'react';

import AnchorLink from '../AnchorLink';

import styles from './Container.module.scss';

interface Props {
  children: React.ReactNode | Array<React.ReactNode>;
  tableName: string;
  linkText?: string;
  linkUrl?: string;
}

const Container: React.FC<Props> = (props) => {
  return (
    <div className={styles.container}>
      <header className={styles.tableHeader}>
        <h6 className={styles.tableName}>{props.tableName}</h6>
        {props.linkText && props.linkUrl && (
          <AnchorLink className={styles.link} href={props.linkUrl}>
            {props.linkText}
          </AnchorLink>
        )}
      </header>
      <div className={styles.table}>{props.children}</div>
    </div>
  );
};

Container.displayName = 'Container';

export default Container;
